import { useState } from 'react'
import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'

import { useTranslation } from 'react-i18next'
import {
  Box,
  TableCell,
  TableRow,
  Chip,
  Typography,
  MenuItem,
  ListItemText,
} from '@mui/material'
import { Calculate, Delete, Sync, Visibility } from '@mui/icons-material'

import { colors } from '@/theme/colors.theme'
import routes from '@/routes'
import { WalletLibraryColumnProps } from '@/state/wallets/models'

import { WalletsStatusLabels } from '@/constants/wallets'
import { BonusStatusEnum, BonusType, BonusWalletStatusType } from '@/enums'
import { useWalletsTable } from '@/views/wallets/hooks/use-wallets-table.hook'

import {
  TableMenuButtonComponent,
  TableMenuComponent,
} from '@/views/components'
import { ApplicationState } from '@/state/root.models'

type Props = {
  row: WalletLibraryColumnProps
}

export const WalletsTableRowComponent = ({ row }: Props) => {
  const { t } = useTranslation()

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const {
    handleForfeitWallet,
    handleCalculateRollover,
    handleSyncBetsoftBonus,
  } = useWalletsTable()

  const anchorPosition = {
    top: anchorEl?.getBoundingClientRect().top,
    left: anchorEl?.getBoundingClientRect().left,
  }

  const { freePlaysCalculated } = useSelector(
    ({ wallet }: ApplicationState) => wallet,
  )

  const freePlaysTemp = freePlaysCalculated
    ? freePlaysCalculated.filter(
        (item) => item.playerId === row.playerId.toString(),
      )
    : []

  let disabledFreePlayCalculate = false

  if (freePlaysTemp.length > 0) {
    const currenDate = new Date()
    const lastDate = new Date(freePlaysTemp[0].timestamp as string)

    const miliSeconds = Number(currenDate) - Number(lastDate)

    const minutes = miliSeconds / (1000 * 60)

    disabledFreePlayCalculate = minutes < 5
  }

  return (
    <>
      <TableRow hover>
        <TableCell>
          <Chip
            variant="filled"
            size="medium"
            label={
              WalletsStatusLabels[row.status as BonusWalletStatusType].label
            }
            className={
              WalletsStatusLabels[row.status as BonusWalletStatusType].color
            }
            sx={{ width: '100%' }}
          />
        </TableCell>
        <TableCell>{row.bonusName}</TableCell>
        <TableCell>{row.createdAt}</TableCell>
        <TableCell>
          {row.walletType.toString() !== BonusType.FREE_SPINS &&
          row.walletType.toString() !== BonusType.BETSOFT_CASINO ? (
            <NavLink
              title="Transactions"
              className="customLink"
              to={`${routes.transactions.INDEX}/?id=${row.id}&type=${row.walletType}`}
            >
              <Typography>{row.id}</Typography>
              <Visibility />
            </NavLink>
          ) : (
            <Typography>{row.id}</Typography>
          )}
        </TableCell>
        <TableCell>{row.playerId}</TableCell>
        <TableCell>{row.username}</TableCell>
        <TableCell>{row.bonusCode}</TableCell>
        <TableCell>{row.walletTypeLabel}</TableCell>
        <TableCell>{row.grantedDepositText}</TableCell>
        <TableCell>{row.grantedAmountText}</TableCell>
        <TableCell>{row.freeSpinsGranted}</TableCell>
        <TableCell>{row.bonusBalanceAtNumber}</TableCell>
        <TableCell>{row.rolloverAmountGranted}</TableCell>
        {/* <TableCell>
          {row.walletType.toString() === BonusType.FREE_PLAY ? (
            <NavLink
              title="Contributions"
              className="customLink"
              to={`${routes.contributions.INDEX}/?id=${row.id}`}
            >
              <Typography>{row.rollover}</Typography>
              <Visibility />
            </NavLink>
          ) : (
            <Typography>{row.rollover}</Typography>
          )}
        </TableCell> */}
        <TableCell>{row.deposiId}</TableCell>
        <TableCell>{row.assignedBy}</TableCell>
        {row.status === BonusStatusEnum.Active ||
        // row.walletType.toString() === BonusType.FREE_PLAY ||
        row.walletType.toString() === BonusType.BETSOFT_CASINO ? (
          <TableMenuButtonComponent setAnchorEl={setAnchorEl} />
        ) : (
          <TableCell
            sx={{
              position: 'sticky',
              right: 0,
              width: '50px',
              textAlign: 'center',
            }}
          >
            -
          </TableCell>
        )}
      </TableRow>
      <TableMenuComponent
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        extraOptions={
          <Box>
            {row.status === BonusStatusEnum.Active && (
              <MenuItem
                key="forfeit"
                onClick={() =>
                  handleForfeitWallet(anchorPosition, row.id.toString())
                }
              >
                <Delete
                  fontSize="inherit"
                  sx={{ color: colors.red, mr: 0.5 }}
                />
                <ListItemText primary={t('labels.forfeit')} />
              </MenuItem>
            )}
            {/* {row.walletType.toString() === BonusType.FREE_PLAY && (
              <MenuItem
                key="calculate"
                onClick={() =>
                  handleCalculateRollover(
                    anchorPosition,
                    row.playerId.toString(),
                  )
                }
                disabled={disabledFreePlayCalculate}
              >
                <Calculate fontSize="inherit" sx={{ mr: 0.5 }} />
                <ListItemText primary={t('wallet.calculateRollover')} />
              </MenuItem>
            )} */}
            {row.walletType.toString() === BonusType.BETSOFT_CASINO && (
              <MenuItem
                key="sync"
                onClick={() =>
                  handleSyncBetsoftBonus(anchorPosition, row.id.toString())
                }
              >
                <Sync fontSize="inherit" sx={{ mr: 0.5 }} />
                <ListItemText primary={t('wallet.syncBonus')} />
              </MenuItem>
            )}
          </Box>
        }
      />
    </>
  )
}
